import revive_payload_client_4sVQNw7RlN from "/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_A0OWXRrUgq from "/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import clickOutside_ZB3Eg0wOVk from "/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/plugins/clickOutside.ts";
import fb_customer_chat_0cylOHv5Px from "/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/plugins/fb-customer-chat.js";
import gtag_client_R70iZRv6jK from "/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/plugins/gtag.client.js";
import useBootstrap_client_ouDJvcVteA from "/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/plugins/useBootstrap.client.ts";
import woo_OJr6MI1btp from "/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/plugins/woo.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  clickOutside_ZB3Eg0wOVk,
  fb_customer_chat_0cylOHv5Px,
  gtag_client_R70iZRv6jK,
  useBootstrap_client_ouDJvcVteA,
  woo_OJr6MI1btp
]